// extracted by mini-css-extract-plugin
export default {"root":"Thumbnail_root__u64Ul","selected":"Thumbnail_selected__PZL5U","image":"Thumbnail_image__pOEvk","overlay":"Thumbnail_overlay__FszDC"};